<template>
  <div class="d-flex flex-column" style="gap: 5px;">
    <div class="d-flex align-center justify-space-between">
      <span class="text-caption text-uppercase font-weight-medium grey--text">
        {{ label }}
      </span>
      <v-chip color="#f1f1f1" small rounded dense>
        {{ localValue[0] }}&ndash;{{ localValue[1] }}{{ unit }}
      </v-chip>
    </div>
    <v-range-slider
      v-model="localValue"
      :min="min"
      :max="max"
      step="1"
      color="secondary"
      track-color="grey lighten-2"
      hide-details
      @input="$emit('input', localValue)"
    />
    <div class="d-flex justify-space-between" style="margin-top: -4px;">
      <span class="text-caption grey--text" style="font-size: 9px;">
        {{ min }}{{ unit }}
      </span>
      <span class="text-caption grey--text" style="font-size: 9px;">
        {{ max }}{{ unit }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "a-pricing-strategy-rule-type-condition-field-range-slider",
  props: {
    value: { type: Array, default: () => [0, 100] },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    label: { type: String, default: "" },
    unit: { type: String, default: "" }
  },
  data() {
    return {
      localValue: this.value ? [...this.value] : [this.min, this.max]
    };
  },
  watch: {
    value(v) {
      if (v && (v[0] !== this.localValue[0] || v[1] !== this.localValue[1])) {
        this.localValue = [...v];
      }
    }
  }
};
</script>
